import React from 'react';
import { ISVGType } from './SVGType';

const UpArrowSVG = (props: ISVGType) => {
  const { width = 8, height = 10, color = "#0CAB7C" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 8 10"
      fill="none"
    >
      <path
        d="M4.66413 2.49379C4.88161 2.73675 5.08137 2.96013 5.28149 3.18315C5.69356 3.64174 6.10082 4.10438 6.52101 4.55522C6.69122 4.73799 6.84593 4.94439 7.12175 5.00125C7.44335 5.06771 7.88938 4.84211 7.93332 4.40457C7.9636 4.10365 7.80298 3.89208 7.61578 3.68863C7.21332 3.25109 6.81196 2.81244 6.41171 2.37268C6.16913 2.1061 5.9306 1.83545 5.68876 1.56812C5.33023 1.17157 4.96543 0.780181 4.61429 0.377348C4.48136 0.224855 4.35878 0.0779001 4.14942 0.0265772C3.90019 -0.0347155 3.6757 0.00626869 3.49994 0.188669C3.12813 0.574517 2.76849 0.972182 2.40295 1.36431C2.00603 1.79003 1.60799 2.21465 1.21107 2.64038C0.992483 2.87484 0.773897 3.1093 0.558265 3.34635C0.420172 3.49774 0.282817 3.65023 0.153586 3.80937C-0.165431 4.2026 0.0365388 4.76864 0.535742 4.89713C0.761343 4.95547 1.00171 4.90599 1.17673 4.72137C1.58399 4.29269 1.98609 3.85921 2.38929 3.42684C2.61083 3.18906 2.83126 2.95016 3.05059 2.71016C3.12074 2.63373 3.18646 2.55324 3.27914 2.44579C3.27914 2.52665 3.27914 2.57428 3.27914 2.62191C3.27914 4.85577 3.28025 7.08963 3.27914 9.32349C3.27914 9.66171 3.51065 9.8851 3.78758 9.97223C4.19115 10.0993 4.67004 9.77802 4.6682 9.26331C4.65897 7.06637 4.66413 4.86944 4.66413 2.6725L4.66413 2.49379Z"
        fill={color}
      />
    </svg>
  )
};

export default UpArrowSVG;
